<template>
  <v-btn
    icon
    color="primary"
    variant="text"
    density="comfortable"
    :class="showBadge ? 'mr-2' : ''"
    :aria-label="$t('openFilter')"
    @click="$emit('toggle')"
  >
    <v-badge
      :model-value="showBadge"
      :content="activeFilters"
      :offset-x="-2"
      :offset-y="16"
      bordered
      color="primary"
    >
      <v-icon size="32" :icon="mdiFilterOutline" />
    </v-badge>
  </v-btn>
</template>

<script setup lang="ts">
import { mdiFilterOutline } from '@mdi/js'
import { computed } from 'vue'

const props = defineProps({
  activeFilters: {
    type: Number,
    required: true
  }
})

defineEmits(['toggle'])

const showBadge = computed(() => props.activeFilters > 0)
</script>
